<template>
  <label
    class="text-field"
    :class="{
      'text-field--focus': focus,
      'text-field--has-content': value && value.length > 0,
    }"
    :for="name"
  >
    <span class="text-field__label">{{ label }}</span>
    <input
      v-if="type === 'single'"
      class="text-field__input"
      :class="{
        'text-field__input--lg': size === 'lg',
        'text-field__input--sm': size === 'sm',
      }"
      type="text"
      @focus="focus = true"
      @blur="focus = false"
      @input="$emit('input', $event.target.value)"
      :value="value"
      :name="name"
      :id="name"
      :placeholder="placeholder"
    />
    <textarea
      v-if="type === 'multi'"
      class="text-field__input"
      rows="16"
      @focus="focus = true"
      @blur="focus = false"
      @input="$emit('input', $event.target.value)"
      :value="value"
      :name="name"
      :id="name"
      :placeholder="placeholder"
    />
  </label>
</template>

<script>
export default {
  name: 'text-field',
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: true,
      validator: function(val) {
        return ['single', 'multi'].includes(val);
      },
    },
    size: {
      type: String,
      required: false,
      default: 'md',
      validator: function(val) {
        return ['sm', 'md', 'lg'].includes(val);
      },
    },
    value: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      focus: false,
      val: '',
    };
  },
};
</script>
